import { render } from "./AppHeaderDropdownAccnt.vue?vue&type=template&id=1f10880c&scoped=true"
import script from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"

import "./AppHeaderDropdownAccnt.vue?vue&type=style&index=0&id=1f10880c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f10880c"]])

export default __exports__